import FormattedMessage from 'I18n/components/FormattedMessage';
import formatName from 'I18n/utils/formatName';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { getTypeAction } from '../../utils/i18nUtils';
import { unreachableFallback } from 'ui-product-approvals-common/utils/unreachableFallback';
import { ApprovalRules } from '../../types';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalModalMessageI18nApprove = () => {
  const {
    data,
    meta
  } = useApprovalContext();
  if (!data) {
    return null;
  }
  const {
    approvalType,
    approvalAction,
    stepCount
  } = meta;
  const typeAction = getTypeAction(approvalType, approvalAction);
  const options = {
    count: stepCount,
    formattedName: formatName(data.requester)
  };
  if (data.approvalRules === ApprovalRules.ANY_CAN_APPROVE) {
    switch (typeAction) {
      case 'MARKETING_EMAIL-PUBLISH':
        {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalModalMessage.APPROVE_RULE_ANY.MARKETING_EMAIL-PUBLISH",
            options: options
          });
        }
      case 'LANDING_PAGE-PUBLISH':
        {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalModalMessage.APPROVE_RULE_ANY.LANDING_PAGE-PUBLISH",
            options: options
          });
        }
      case 'SITE_PAGE-PUBLISH':
        {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalModalMessage.APPROVE_RULE_ANY.SITE_PAGE-PUBLISH",
            options: options
          });
        }
      case 'BLOG_POST-PUBLISH':
        {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalModalMessage.APPROVE_RULE_ANY.BLOG_POST-PUBLISH",
            options: options
          });
        }
      case 'DEAL-MOVE_STAGE':
        {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalModalMessage.APPROVE_RULE_ANY.DEAL-MOVE_STAGE",
            options: options
          });
        }
      case 'KNOWLEDGE_ARTICLE-PUBLISH':
        {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalModalMessage.APPROVE_RULE_ANY.KNOWLEDGE_ARTICLE-PUBLISH",
            options: options
          });
        }
      case 'QUOTE-PUBLISH':
        {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalModalMessage.APPROVE_RULE_ANY.QUOTE-PUBLISH",
            options: options
          });
        }
      case 'SOCIAL_BROADCAST-PUBLISH':
        {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalModalMessage.APPROVE_RULE_ANY.SOCIAL_BROADCAST-PUBLISH",
            options: options
          });
        }
      case 'CONNECTED_APP-INSTALL':
        {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.ApprovalModalMessage.APPROVE_RULE_ANY.CONNECTED_APP-INSTALL",
            options: options
          });
        }
      default:
        return unreachableFallback(typeAction, /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.unhandled.approvalType"
        }));
    }
  }
  switch (typeAction) {
    case 'MARKETING_EMAIL-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalModalMessage.APPROVE.MARKETING_EMAIL-PUBLISH",
          options: options
        });
      }
    case 'LANDING_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalModalMessage.APPROVE.LANDING_PAGE-PUBLISH",
          options: options
        });
      }
    case 'SITE_PAGE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalModalMessage.APPROVE.SITE_PAGE-PUBLISH",
          options: options
        });
      }
    case 'BLOG_POST-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalModalMessage.APPROVE.BLOG_POST-PUBLISH",
          options: options
        });
      }
    case 'DEAL-MOVE_STAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalModalMessage.APPROVE.DEAL-MOVE_STAGE",
          options: options
        });
      }
    case 'KNOWLEDGE_ARTICLE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalModalMessage.APPROVE.KNOWLEDGE_ARTICLE-PUBLISH",
          options: options
        });
      }
    case 'QUOTE-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalModalMessage.APPROVE.QUOTE-PUBLISH",
          options: options
        });
      }
    case 'SOCIAL_BROADCAST-PUBLISH':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalModalMessage.APPROVE.SOCIAL_BROADCAST-PUBLISH",
          options: options
        });
      }
    case 'CONNECTED_APP-INSTALL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalModalMessage.APPROVE.CONNECTED_APP-INSTALL",
          options: options
        });
      }
    default:
      return unreachableFallback(typeAction, /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.unhandled.approvalType"
      }));
  }
};